import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { authFetch } from '../../utils/authFetch';
import { formatDate } from '../../components/DateDisplay';
import { applyPhoneMask } from '../../utils/masks';

const VisualizarTriagem = () => {
    const { id } = useParams();
    
    const [triagem, setTriagem] = useState({
        patientName: '',
        parentsName: '',
        birthdate: '',
        age: '',
        contact: '',
        firstContactDate: '',
        screeningDate: '',
        referral: '',
        demand: '',
        demandDescription: '',
        therapistName: '',
        potentialPatient: false,
        returnDate: '',
        observations: '',
        patientId: null,
        patientNameLinked: '',
        nonPotentialPatientReason: ''
    });

    const indicacoes = {
        'Instagram': 'Instagram',
        'Site': 'Site',
        'Instagram/Site': 'Instagram/Site',
        'Médico/Afins': 'Médico/Afins',
        'Amigo ou Familiar': 'Amigo ou Familiar',
        'Escola': 'Colégio',
        'Outro': 'Outro'
    };

    const demandas = {
        'AVALIACAO': 'Avaliação',
        'INTERVENCAO': 'Intervenção',
        'PSICOTERAPIA': 'Psicoterapia'
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await authFetch(`screening/${id}`);
                if (!res.ok) throw new Error();
                const data = await res.json();
                
                // Buscar nome do paciente vinculado se houver
                let patientNameLinked = '';
                if (data.patientId) {
                    try {
                        const pacienteRes = await authFetch(`patient/${data.patientId}`);
                        if (pacienteRes.ok) {
                            const pacienteData = await pacienteRes.json();
                            patientNameLinked = pacienteData.name;
                        }
                    } catch (err) {
                        console.error('Erro ao buscar paciente:', err);
                    }
                }

                setTriagem({
                    ...data,
                    patientNameLinked
                });
            } catch (err) {
                console.error('Erro ao carregar triagem:', err);
            }
        };

        fetchData();
    }, [id]);

    return (
        <div className="content">
            <div className="card">
                <div className="card-body p-3">
                    <div className="row col-md-12 mb-3">
                        <div className="col-md-10">
                            <h2>Visualizar Triagem</h2>
                        </div>
                        <div className="col-md-2 text-end">
                            <Link to="/Triagens" className="btn btn-info btn-sm">Voltar</Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <label>Nome do Paciente</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.patientName || '-'} 
                                readOnly
                            />
                        </div>
                        <div className="col-md-4">
                            <label>Nome dos Pais</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.parentsName || '-'} 
                                readOnly
                            />
                        </div>
                        <div className="col-md-2">
                            <label>Data de Nascimento</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.birthdate ? formatDate(triagem.birthdate) : '-'} 
                                readOnly
                            />
                        </div>
                        <div className="col-md-2">
                            <label>Idade</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.age || '-'} 
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-4">
                            <label>Contato (Telefone)</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.contact ? applyPhoneMask(triagem.contact) : '-'} 
                                readOnly
                            />
                        </div>
                        <div className="col-md-4">
                            <label>Lead</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.referral ? (indicacoes[triagem.referral] || triagem.referral) : '-'} 
                                readOnly
                            />
                        </div>
                        <div className="col-md-2">
                            <label>Data Primeiro Contato</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.firstContactDate ? formatDate(triagem.firstContactDate) : '-'} 
                                readOnly
                            />
                        </div>
                        <div className="col-md-2">
                            <label>Data Triagem</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.screeningDate ? formatDate(triagem.screeningDate) : '-'} 
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-3">
                            <label>Demanda</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.demand ? (demandas[triagem.demand] || triagem.demand) : '-'} 
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-12">
                            <label>Descrição da Demanda</label>
                            <textarea 
                                className="form-control form-control-sm" 
                                value={triagem.demandDescription || '-'} 
                                readOnly
                                rows={3}
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-4">
                            <label>Terapeuta</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.therapistName || triagem.therapist?.name || '-'} 
                                readOnly
                            />
                        </div>
                        <div className="col-md-4">
                            <label>Potencial Paciente?</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.potentialPatient ? 'Sim' : 'Não'} 
                                readOnly
                            />
                        </div>
                        <div className="col-md-4">
                            <label>Data Retorno do Contato</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.returnDate ? formatDate(triagem.returnDate) : '-'} 
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-12">
                            <label>Observações</label>
                            <textarea 
                                className="form-control form-control-sm" 
                                value={triagem.observations || '-'} 
                                readOnly
                                rows={3}
                            />
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-3">
                            <label>Tornou-se Paciente?</label>
                            <input 
                                type='text' 
                                className='form-control form-control-sm' 
                                value={triagem.patientId ? 'Sim' : 'Não'} 
                                readOnly
                            />
                        </div>
                        {triagem.patientId && (
                            <div className="col-md-9">
                                <label>Paciente Vinculado</label>
                                <input 
                                    type='text' 
                                    className='form-control form-control-sm' 
                                    value={triagem.patientNameLinked || '-'} 
                                    readOnly
                                />
                            </div>
                        )}
                        {!triagem.patientId && triagem.nonPotentialPatientReason && (
                            <div className="col-md-9">
                                <label>Justificativa</label>
                                <textarea 
                                    className='form-control form-control-sm' 
                                    value={triagem.nonPotentialPatientReason} 
                                    readOnly
                                    rows={3}
                                />
                            </div>
                        )}
                    </div>

                    <div className="card-footer" style={{ paddingLeft: 0, marginTop: '20px' }}>
                        <Link to="/Triagens" className="btn btn-info btn-sm">Voltar</Link>
                        <Link to={`/Triagens/Editar/${id}`} className="btn btn-primary btn-sm mx-1">Editar</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VisualizarTriagem;

